<template>
  <div class="about">
    <div class="md-layout travel md-alignment-center">
      <div class="md-layout-item md-size-100 bigTitle">Une vie d'Aventure</div>
      <div
        :key="a.title"
        v-for="a in getAllAdventuresList"
        class="md-layout-item md-xlarge-size-70 md-large-size-70 md-small-size-90 md-layout adventure"
        @click="goToAdventure(a)"
      >
        <div
          class="md-layout-item md-xlarge-size-50 md-large-size-50 md-small-size-100 adventureImage lastArticleImage"
          :style="{ 'background-image' : getUrl(a) }"
        ></div>
        <div
          class="md-layout-item md-xlarge-size-50 md-large-size-50 md-small-size-100 adventureMiniContent"
        >
          <div class="contentTitle">
            <b>{{a.title}}</b>
          </div>
          <div class="contentBody">{{a.desc}}</div>
          <div class="flagsContainer">
            <img
              :key="f"
              v-for="f in getArtCountryMap[a.ownId] ? getArtCountryMap[a.ownId].map((country) => `https://www.countryflags.io/${country.toLowerCase()}/flat/32.png`) : []"
              :src="f"
            />
            {{ getArticleAdMap[a.ownId] ? getArticleAdMap[a.ownId].length : 0}} articles
          </div>
          <div class="flagsContainer"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// @ is an alias to /src

export default {
  name: "travel",
  computed: {
    ...mapGetters([
      "getAllAdventuresList",
      "getArticleAdMap",
      "getArtCountryMap"
    ])
  },
  methods: {
    ...mapActions(["setCurrentAdventure"]),
    getUrl(c) {
      return `url('${c.image}')`;
    },
    goToAdventure(a) {
      this.setCurrentAdventure(a);
      this.$router.push("adventure");
    }
  },
  components: {}
};
</script>

<style >
.travel {
  background-color: #d4dadc !important;
  text-align: center;
}
.bigTitle {
  font-size: 30px;
  margin: 30px;
}

.adventure {
  height: 200px;
  margin: 20px !important;
}

.adventureImage {
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.adventureMiniContent {
  background-color: #046380 !important;
  color: #efecca !important;
}

.adventureMiniContent:hover {
  cursor: pointer;
}
.contentTitle {
  margin: 20px;
  text-align: left;
}

.contentBody {
  margin: 20px;
  text-align: left;
}

.flagsContainer {
  text-align: left;
  padding-left: 20px;
}

@media only screen and (max-width: 959px) {
  .adventure {
    height: auto;
    margin: 20px !important;
  }

  .adventureMiniContent {
    padding-bottom: 10px;
  }
}
</style>
